import { HTTP_TOKEN, HTTP_TOKEN_REPORT } from "./http";

export const getShortLinks = params => {
  return HTTP_TOKEN.get("shortlink", { params }).then(result => {
    return result.data;
  });
};

export const getShortLinksReport = params => {
  return HTTP_TOKEN_REPORT.get("shortlink-log", { params }).then(result => {
    return result.data;
  });
};

export const getShortLink = (slId) => {
  return HTTP_TOKEN.get(`shortlink/${slId}`).then(result => {
    return result.data;
  });
};


export const createShortLink = data => {
  return HTTP_TOKEN.post("shortlink", data).then(result => {
    return result.data;
  });
};

export const updateShortLink = (slId, data) => {
  return HTTP_TOKEN.put(`shortlink/${slId}`, data).then(result => {
    return result.data;
  });
};

export const deleteShortLink = (slId) => {
  return HTTP_TOKEN.delete(`shortlink/${slId}`).then(result => {
    return result.data;
  });
};
